const filterTemplateType = (filterType, templatesData) => {
  return templatesData.filter((template) => template?.type.toLowerCase() === filterType);
};

export default filterTemplateType;
